import Clipboard from "clipboard";
import _ from "lodash";
import { popUp } from "../controls/popUp";
import { alert } from "../core/alert";
import { deepClone } from "../core/core";
import { date } from "../core/date";
import * as dateUtil from "../core/dateTime";
import { bind } from "../core/kendo";
import { ll, LocalizedLanguage } from "../core/ll";
import { getToken } from "../core/token";
import { user } from "../core/user";
import { Grid } from "./components";
import view from "./logHelper.view";

let fullLog = [];

let lastCoupleEvents = [];

export const requests = [];

let lastPingRequests = [];

let userData: any;

let clipboard: Clipboard;

let errorCount: any = 0;

export function setUserData(data: any) {
    userData = data;
}

export function init() {
    // The next two event handlers will grab all console errors
    var caughtIt = false;

    // Removing since this event syntax really does not give us much anymore
    // window.addEventListener("error", function (evt) {
    //     if (!caughtIt) {
    //         addErrorReminder();
    //         caughtIt = true;
    //         buildLogMessage({
    //             type: "Console",
    //             evt: evt
    //         });

    //         $.wait(10).then(function () { caughtIt = false; });
    //     }
    // });

    window.onerror = function (msg, url, line, character, error) {
        if (!caughtIt && msg && url && line) {
            caughtIt = true;
            addErrorReminder();
            buildLogMessage({
                type: "Console",
                evt: {
                    message: msg,
                    filename: url,
                    lineno: line,
                    error: error
                }
            });

            $.wait(10).then(function () { caughtIt = false; });
        }
    };

    // Grab all ajax errors
    $(document).ajaxError(function (event, jqXHR, ajaxSettings, thrownError) {
        addErrorReminder();
        buildLogMessage({
            type: "Ajax",
            evt: event,
            jqXHR: jqXHR,
            ajaxSettings: ajaxSettings,
            thrownError: thrownError
        });
    });

    // Grab all ping requests
    $(document).ajaxSend(function (event, request, settings) {
        if (settings && settings.url && settings.url.indexOf("/service/api/Executing/Ping?guid=") != -1) {
            var guid = settings.url.replace("/service/api/Executing/Ping?guid=", "");
            if (!_.find(lastPingRequests, function (e) { return e.Guid == guid; })) {
                lastPingRequests.push({
                    Type: "PingRequest",
                    Guid: guid,
                    Url: settings.url
                });
            }
        }

        if (settings && settings.headers && settings.headers["Correlation-Id"]) {
            lastCoupleEvents.push(settings.headers["Correlation-Id"]);
            if (lastCoupleEvents.length > 100) {
                lastCoupleEvents.splice(0, 1);
            }
        }
    });

    // Setup the CTRL + ~ event to open pop up
    $(document).on("keydown", function (e) {
        // Used to test failures
        // if (e.keyCode == 88) {
        //    a = b;
        // } else if (e.keyCode == 90) {
        //    z.ajax({ url: "Test", data: { test: "test", foo: [] } });
        //    z.ajax({ type: "POST", url: "POST", data: { test: "test", foo: ["foo"] }, contentType: "application/json" });
        // }

        if (e.ctrlKey && e.keyCode == 192) {
            userData = getUserData();
            buildLogPopUp();
        } else {
            // pushEvent(e);
        }
    });

    // $(document).on("click", function (e) {
    //     pushEvent(e);
    // });
}

function addErrorReminder() {
    errorCount < 99 ? errorCount += 1 : errorCount = "99+";
    if ($("#ErrorLight").length == 0) {
        $("#AdminMenu").children().first().append($(`<div id="ErrorLight" class="circle banner-error">${errorCount}</div>`));
        $("#ShowErrorReport").children().append($(`<div id="ErrorLightMenu" class="circle menu-error">${errorCount}</div>`));
    } else {
        $("#ErrorLight").text(errorCount);
        $("#ErrorLightMenu").text(errorCount);
    }
}
function pushEvent(e) {
    if (lastCoupleEvents.length > 1000) {
        lastCoupleEvents.shift();
    }

    var target = $(e.target);

    lastCoupleEvents.push({
        type: e.type,
        targetId: target.attr("id"),
        targetClasses: target.attr("class"),
        path: target.getPath(),
        character: String.fromCharCode(e.keyCode)
    });

    consolidateKeydownEvents();
}

function consolidateKeydownEvents() {
    var length = lastCoupleEvents.length;

    if (length < 2) {
        return;
    }

    var lastEvent = lastCoupleEvents[length - 1],
        penultimateEvent = lastCoupleEvents[length - 2];

    if (lastEvent.type == "keydown" && penultimateEvent.type == "keydown" && lastEvent.targetId == penultimateEvent.targetId && lastEvent.path == penultimateEvent.path) {
        lastCoupleEvents.pop();
        penultimateEvent.character += lastEvent.character;
    }
}

export function getUserData() {
    var data = deepClone(user);

    if (data.loginData) {
        delete data.loginData.LocalizedLabels;
        delete data.loginData.SecretKey;
    }

    if (data.companyData) {
        delete data.companyData.LocalizedLabels;
        delete data.companyData.UserDefinedFields;
        delete data.companyData.UserDefinedLists;
        delete data.companyData.AppSettings;
        delete data.companyData.Settings;
        delete data.companyData.UserGroup;
        delete data.companyData.Default;

        data.companyData.Options = _.map(data.companyData.Options, (o: any) => {
            var result = {} as any;

            result[o.OptionNumber] = o.Value;

            return result;
        });
    }

    if (data.myDivision) {
        delete data.myDivision.CreatedDateTime;
        delete data.myDivision.CreatedGroup;
        delete data.myDivision.CreatedUserId;
        delete data.myDivision.DeletedDateTime;
        delete data.myDivision.LastUpdatedDateTime;
        delete data.myDivision.LastUpdatedUserIt;
        delete data.myDivision.Notes;
    }

    return data;
}

export function buildLogPopUp() {

    if (fullLog.length == 0) {
        alert({
            type: "warning",
            header: ll("NoErrorsToReport"),
            message: ll("NoErrorsToReportMessage"),
            wait: 5000
        });
    }

    var entireLog = [];

    entireLog.push(fullLog);

    entireLog.push(userData);

    entireLog.push(lastCoupleEvents);

    entireLog.push(lastPingRequests);

    if ($("#ErrorReportPopUp").length > 0) {
        $("#ErrorReportPopUp").parents(".k-window").remove();
    }

    var height = $(window).height() - 50,
        errorReportPopUp = popUp({
            id: "ErrorReportPopUp",
            title: ll("ErrorReport") + " for " + user.loginData.UserName,
            width: $(window).width() - 25,
            height: height,
            buttons: [
                {
                    name: ll("Close"),
                    className: "left",
                    clickEvent: function () {
                        errorReportPopUp.window.close();
                    }
                },
                {
                    name: ll("CopyToClipboard"),
                    id: "CopyToClipboard"
                }
            ]
        });

    var logHelperLayout = view();
    logHelperLayout.options.zScreen = errorReportPopUp;
    logHelperLayout && logHelperLayout.render && logHelperLayout.render(errorReportPopUp.guts);

    bind({ container: errorReportPopUp.window.element, bind: ".bind-label", data: LocalizedLanguage });

    var textarea = errorReportPopUp.get("#FullLog");
    textarea.attr("id", "FullLog");
    textarea.val(JSON.stringify(entireLog, null, 4));
    textarea.css("height", height - 90);
    errorReportPopUp.get("#QuickViewContainer").css("height", height - 90);
    errorReportPopUp.container.attr("id", "ErrorReportPopUp");
    textarea.focus()[0].select();
    textarea.scrollTop(0);

    var copyBtn = errorReportPopUp.get("#CopyToClipboard");
    copyBtn.attr("id", "CopyToClipboard");

    // ReSharper disable once ConstructorCallNotUsed
    if (!clipboard) {
        clipboard = new Clipboard("#" + copyBtn.attr("id"),
        {
            text: function () {
                return JSON.stringify(entireLog, null, 4);
            }
        });

        clipboard.on("success", function () {
            alert({
                type: "success",
                header: ll("CopiedErrorReportText"),
                message: ll("CopiedErrorReportTextMessage"),
                wait: 5000
            });
        });
    }

    var consoleErrors = $.grep(fullLog, function (log) {
        return log.Type == "Console";
    });

    var ajaxErrors = $.grep(fullLog, function (log) {
        return log.Type == "Ajax";
    });

    errorReportPopUp.get("#RequestResponseErrorCount").html(ajaxErrors.length);
    errorReportPopUp.get("#ConsoleErrorCount").html(consoleErrors.length);

    if (ajaxErrors.length > 0) {
        errorReportPopUp.get("#RequestResponseErrorCount").addClass("badge-error");
    }

    if (consoleErrors.length > 0) {
        errorReportPopUp.get("#ConsoleErrorCount").addClass("badge-error");
    }

    var errorGrid = errorReportPopUp.get("#ErrorGrid").data("me") as Grid;
    errorGrid.build({
        id: "ErrorGrid",
        zScreen: errorReportPopUp,
        pageable: false,
        gridColumns: [
            { field: "Type", width: 58 },
            { field: "TimeStamp", template: "#= z.util.kendoFormatDateTime(TimeStamp) #", width: 125 },
            {
                field: "URL",
                width: 200,
                template: "<textarea>#= data.URL #</textarea>",
                attributes: {
                    "class": "grid-special-textarea-column"
                }
            },
            { field: "LineNo", title: "Line#", width: 62 },
            { field: "StatusMessage", width: 113 },
            { field: "RequestType", width: 102 },
            {
                field: "Data",
                title: "RequestData",
                template: "<textarea>#= data.Data #</textarea>",
                attributes: {
                    "class": "grid-special-textarea-column"
                }
            },
            {
                field: "Response",
                template: "<textarea>#= JSON.stringify(data.Response, null, 4) #</textarea>",
                attributes: {
                    "class": "grid-special-textarea-column"
                }
            },
            {
                field: "Stack",
                template: "<textarea>#= data.Stack #</textarea>",
                attributes: {
                    "class": "grid-special-textarea-column"
                }
            }
        ],
        dataSource: fullLog,
        height: height - 245
    });

    $.wait(100).then(function () {
        errorGrid.kendoGrid.content.height(errorGrid.kendoGrid.content.height() + 20);
    });

    $("#FullLog").off("change.updateJSON").on("change.updateJSON", function () {
        try {
            var json = $.parseJSON($("#FullLog").val());

            if (!$.isArray(json[0])) {
                alert({
                    type: "warning",
                    message: "Sorry this CTRL ~ is too old to properly inject into the viewer...",
                    wait: 5000
                });
                buildLogPopUp();
                return;
            }

            fullLog = json[0];
            userData = json[1];
            lastCoupleEvents = json[2];

            buildLogPopUp();
        } catch (e) {
            alert({
                type: "warning",
                message: e.message,
                wait: 5000
            });
        }
    });
}

export function buildLogMessage(args) {
    var timeStamp = dateUtil.buildUTCString(date(new Date())),
        logMessage: any = {};

    if (args.type == "Console") {
        logMessage = {
            Type: "Console",
            TimeStamp: timeStamp,
            URL: args.evt.filename,
            LineNo: args.evt.lineno,
            Response: args.evt.message || "",
            Data: "",
            Stack: args.evt.error && args.evt.error.stack
        };
    } else {
        var dataObject = {};

        try {
            dataObject = $.parseJSON(args.ajaxSettings.data);
        } catch (e) {
            dataObject = {};
        }

        dataObject = removePasswords(dataObject);

        logMessage = {
            Type: "Ajax",
            TimeStamp: timeStamp,
            Start: args.jqXHR.startDateTime,
            End: args.jqXHR.endDateTime,
            MsDuration: args.jqXHR.duration,
            ErrorThrown: args.evt.thrownError,
            Status: args.jqXHR.status,
            StatusMessage: args.jqXHR.statusText,
            URL: args.ajaxSettings.url,
            RequestType: args.ajaxSettings.type,
            CorrelationId: args.ajaxSettings.headers["Correlation-Id"],
            CorrelationGroupId: args.ajaxSettings.headers["Correlation-Group-Id"],
            Stack: "",
            Data: JSON.stringify(dataObject) || "",
            Response: args.jqXHR.responseJSON || ""
        };
    }

    if ($.isEmptyObject(logMessage)) {
        logMessage = {
            TimeStamp: timeStamp,
            Message: "Unknown Error"
        };
    }

    logMessage.Token = getToken();
    logMessage.SiteURL = window.location.href;

    fullLog.push(logMessage);
}

function removePasswords(obj) {
    for (var key in obj) {
        if (key.indexOf("Password") != -1 ||
            key.indexOf("password") != -1 ||
            key.indexOf("Pwd") != -1 ||
            key.indexOf("pwd") != -1) {

            delete obj[key];
        } else if ($.type(obj[key]) == "object") {
            obj[key] = removePasswords(obj[key]);
        }
    }

    return obj;
}
